// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Select elements in the DOM
     */

    const markers = document.querySelectorAll('.js-marker');

    for (const marker of markers) {
        marker.addEventListener('click', (e) => {
            const parentMarker = e.target.closest('.marker');
    
            // If the clicked element already has the 'marker--active' class, remove it
            if (parentMarker.classList.contains('marker--active')) {

                parentMarker.classList.remove('marker--active');
                
            } else {

                // Remove the 'marker--active' class from all other elements
                const activeMarkers = document.querySelectorAll('.marker.marker--active');
                for (const activeMarker of activeMarkers) {
                    activeMarker.classList.remove('marker--active');
                }
    
                // Add the 'marker--active' class to the clicked parent element
                parentMarker.classList.add('marker--active');

            }
        });
    }

});
